module.exports = __webpack_public_path__ + "static/img/cw.b42a077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cw.png
// module id = dEHR
// module chunks = 0